// Left.js
import React from 'react';
import { Link } from "react-router-dom";
import { Sidenav, Navbar, Nav, Dropdown, Icon } from 'rsuite';

import Widget from '../widget/Widget';

import 'rsuite/dist/styles/rsuite-default.css';

import './../css/commom.css';

class Left extends React.Component 
{
	constructor(props) 
	{
		super();

		this.state = {
			openKey : [],
			activeKey: props.activeKey,
			isState:false,
		};

		
		
		this.findOpenKey = this.findOpenKey.bind(this);
		this.handleSelect = this.handleSelect.bind(this);
		this.setActiveKey = this.setActiveKey.bind(this);
		this.findFirstNode = this.findFirstNode.bind(this);
		this.onMouseEnter = this.onMouseEnter.bind(this);
		this.onMouseLeave = this.onMouseLeave.bind(this);
		
		this.handleSheetPathSelect = this.handleSheetPathSelect.bind(this);
	}

	/**
	 * 处置选择
	 * @param {*} eventKey 
	 */
	handleSelect(eventKey) 
	{
		let openKey = [];

		this.findOpenKey(openKey, this.props.leftNode, eventKey);

		this.findOpenKey(openKey, this.props.disposalData, eventKey);

		this.setState({
			activeKey: eventKey,
			openKey : openKey,
			isState : true
	 	});

		Widget.addSessionStorage("_left_node_activeKey_", eventKey);
		Widget.addSessionStorage("_left_node_openKey_", openKey);

		if( this.props.leftOnSelect!==undefined )
		{
			this.props.leftOnSelect(eventKey);
		}
	}

	setActiveKey( key )
	{
		let openKey = [];

		this.findOpenKey(openKey, this.props.leftNode, key);

		this.findOpenKey(openKey, this.props.disposalData, key);

		this.setState({
			activeKey: key,
			openKey : openKey,
			isState : true
	 	});

		Widget.addSessionStorage("_left_node_activeKey_", key);
		Widget.addSessionStorage("_left_node_openKey_", openKey);
	}

	handleSheetPathSelect( eventKey, path, item, parent, sheets, reload)
	{
		let openKey = [];

		if( parent!==undefined )
		{
			this.findOpenKey(openKey, this.props.leftNode, parent.name);
		
			this.setState({
				activeKey: parent.name,
				openKey : openKey,
				isState : true,
			});

			Widget.addSessionStorage("_left_node_activeKey_", parent.name);
		}
		else
		{
			this.findOpenKey(openKey, this.props.leftNode, eventKey);

			this.findOpenKey(openKey, this.props.disposalData, eventKey);
			
			this.setState({
				activeKey: eventKey,
				openKey : openKey,
				isState : true,
			});

			Widget.addSessionStorage("_left_node_activeKey_", eventKey);
		}

		Widget.addSessionStorage("_left_node_openKey_", openKey);
		
		if( path!==undefined && path!==null && this.props.redrict!==undefined )
		{
			if( this.props.leftOnSelect!==undefined )
			{
				this.props.leftOnSelect(eventKey);
			}

			this.props.redrict(path, {item:item, riskType:item.riskType, reload:reload, sheets:sheets}, false);
		}
	}

	/**
	 * 找到第一个节点
	 * @param {*} leftNode 
	 * @returns 
	 */
	findFirstNode( leftNode )
	{
		for( let i=0; i<leftNode.length; i++)
		{
			if( leftNode[i].path!==undefined && leftNode[i].path!==null && leftNode[i].path!=="")
			{
				return leftNode[i];
			}

			if( leftNode[i].subcomponents!==undefined )
			{
				return this.findFirstNode(leftNode[i].subcomponents);
			}
		}
	}

	/**
	 * 根据点击节点找到需要展开的节点的key
	 * @param {*} leftNode 
	 * @param {*} activeKey 
	 */
	findOpenKey(openKey, leftNode, activeKey)
	{
		let isFind = false;

		if( leftNode!==undefined && leftNode!==null )
		{
			for( let i=0; i<leftNode.length; i++)
			{
				if( leftNode[i].name===activeKey )
				{
					isFind = true;
				}
	
				if( isFind===false && leftNode[i].subcomponents!==undefined )
				{
					isFind = this.findOpenKey(openKey, leftNode[i].subcomponents, activeKey);
				}
	
				if( isFind===true )
				{
					openKey.push(leftNode[i].name);
	
					break;
				}
			}
		}
		
		return isFind;
	}

	/**
	 * 鼠标悬浮事件
	 * @param {*} eventKey 
	 * @param {*} path 
	 * @param {*} item 
	 * @param {*} parent 
	 */
	onMouseEnter(eventKey, path, item, parent, e)
	{
		let dom = document.getElementById("ul_" + item.name);

		let dom1 = document.getElementById(item.name);

		dom1.style.height = dom1.offsetHeight + 'px';

		dom.style.top = (0-dom1.offsetHeight) + 'px';
		dom.style.display = "table";
	}

	onMouseLeave(eventKey, path, item, parent, e)
	{
		let dom = document.getElementById("ul_" + item.name);

		dom.style.display = "none";
	}
	
	render() 
	{
		const { leftNode, leftActiveKey } = this.props;

		let { activeKey, openKey, isState} = this.state;

		if( activeKey===undefined )
		{
			activeKey = Widget.getSessionStorage("_left_node_activeKey_");
		}

		if( isState===false && leftActiveKey!==undefined && leftActiveKey!==activeKey )
		{
			this.setActiveKey(leftActiveKey);
		}

		if( openKey===undefined || openKey===null || openKey.length===0 )
		{
			openKey = Widget.getSessionStorage("_left_node_openKey_");

			if( openKey!==undefined && openKey!==null && openKey!=="" )
			{
				openKey = JSON.parse(openKey);
			}
		}

		if( openKey===undefined || openKey===null || openKey.length===0 || activeKey===undefined  )
		{
			if( leftNode!==undefined && leftNode.length>0 )
			{
				openKey = [];

				let node = this.findFirstNode(leftNode);

				activeKey = node.name;

				this.findOpenKey(openKey, leftNode, activeKey);
			}
		}

		this.state["isState"] = false;

	  	return (
			<div className="frame-left">
				<div className="system-title">
					{/* <img src={require("./../img/frame/logo.svg")} alt="es-lint want to get"></img> */}
					银行对公营销获客系统
					{/* <span>Banks have the guest</span> */}
				</div>
				<div className="frame-left-bg">
				{
					leftNode.map((item, index) => {
						if( item.properties!==undefined && item.properties.type==="floating")
						{
							return (
								<Navbar key={item.name} appearance="subtle" className="nav-toggle">
									<Navbar.Body>
										<Nav activeKey={activeKey}>
											<LeftMenu item={item}  activeKey={activeKey} openKey={openKey} onSelect={this.handleSelect} isFirst={true}
												handleSheetPathSelect={this.handleSheetPathSelect} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}/>
										</Nav>
									</Navbar.Body>
								</Navbar>
							)
						}
						else
						{
							return (
								<Sidenav key={item.name} activeKey={activeKey} defaultOpenKeys={openKey} onSelect={this.handleSelect}>
									<Sidenav.Body>
										<Nav pills={"true"}>
											<LeftMenu item={item} activeKey={activeKey} openKey={openKey} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} 
												onSelect={this.handleSelect} handleSheetPathSelect={this.handleSheetPathSelect} isFirst={true} />	
										</Nav>
									</Sidenav.Body>
								</Sidenav>
							)
						}
					})
				}
				</div>
			</div>
		);
	}
}

export const LeftMenu = ({ item, key, activeKey, openKey, onSelect, handleSheetPathSelect, onMouseEnter, onMouseLeave, ...props}) => 
{
	let icon = null, open=false, iconClass, ulClass = "", liClass = "", isFirst= props.isFirst, firstClass = "", sheets = [], isExistChild = false;

	if( item.properties!==undefined && item.properties.icon!==undefined )
	{
		icon = item.properties.icon;

		iconClass = "rs-icon rs-icon-" + icon;
	}

	if( openKey!==undefined && openKey.length>0 )
	{
		for(let i in openKey )
		{
			if( openKey[i]===item.name )
			{
				open = true;

				if( item.properties!==undefined && item.properties.type!=="floating")
				{
					ulClass = "show";
				}
				
				break;
			}	
		}
	}

	if( isFirst )
	{
		firstClass = "first-menu"	
	}


	if( item.subcomponents!==undefined && item.subcomponents.length>0 )
	{
		for( let i=0; i<item.subcomponents.length; i++ )
		{
			if( item.subcomponents[i].type!=="POPUP" && item.subcomponents[i].type!=="SHEET")
			{
				isExistChild = true;
			}

			if( item.subcomponents[i].type==="SHEET" )
			{
				sheets.push(item.subcomponents[i]);
			}
		}
	}	

	if( isExistChild )
	{
		let className = "frame-body-left-nav-title click";
		
		if( activeKey===item.name )
		{
			liClass +=" active";
		}
		else if( open===true )
		{

			liClass += " open";						
		}

		if( icon!==undefined && icon!=="" )
		{
			if( item.properties!==undefined &&  item.properties.type==="floating" )
			{
				ulClass += " floating-window"
				
				return (
					<div id={item.name} key={key}
						onMouseEnter = {( e ) => { onMouseEnter(item.name, item.path, item, props.parent, e)}} 
						onMouseLeave = {( e ) => { onMouseLeave(item.name, item.path, item, props.parent, e)}} 
						className={className} >
						<ul className={firstClass}>
							<li className={liClass} onClick={( e ) => {handleSheetPathSelect(item.name, item.path, item, props.parent, sheets)}} >
								<span className={iconClass}></span>	
								<a>{item.title}</a>
								<span className="rs-dropdown-toggle-right"></span>
							</li>
						</ul>
						
						<ul id={"ul_" + item.name} className={ulClass} style={{display:'none'}}>
						{
							item.subcomponents.map((item, index) => {
								return(
									<LeftMenu item={item} key={item.name} activeKey={activeKey} openKey={openKey} onSelect={onSelect} 
										handleSheetPathSelect = {handleSheetPathSelect} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
									></LeftMenu>
								)
							})
						}
						</ul>
					</div>
				)	
			}
			else
			{
				return (
					<div id={item.name} className={className} key={key}>
						<ul  className={firstClass}>
							<li className={liClass} onClick={( e ) => {handleSheetPathSelect(item.name, item.path, item, props.parent, sheets)}}>
								<span className={iconClass}></span>	
								<a>{item.title}</a>
								<span className="rs-dropdown-toggle-caret"></span>
							</li>
						</ul>
						<ul id={"ul_" + item.name} className={ulClass} style={{display:'none'}}>
						{
							item.subcomponents.map((item, index) => {
								return(
									<LeftMenu item={item} key={item.name} activeKey={activeKey} openKey={openKey} onSelect={onSelect} 
										handleSheetPathSelect = {handleSheetPathSelect} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}
									></LeftMenu>
								)
							})
						}
						</ul>
					</div>
				)	
			}
		}
		else
		{
			if( item.properties!==undefined &&  item.properties.type==="floating" )
			{
				return (
					<div id={item.name} key={key}
						onMouseEnter = {( e ) => { onMouseEnter(item.name, item.path, item, props.parent)}} 
						onMouseLeave = {( e ) => { onMouseLeave(item.name, item.path, item, props.parent, e)}} 
						className={className}>
						<ul className={firstClass}>
							<li className={liClass} onClick={( e ) => { handleSheetPathSelect(item.name, item.path, item, props.parent, sheets ) }} >
								<a>{item.title}</a>
								<span className="rs-dropdown-toggle-right"></span>
							</li>
						</ul>
						
						<ul id={"ul_" + item.name} className={ulClass}  style={{display:'none'}}>
						{
							item.subcomponents.map((item, index) => {
								return(
									<LeftMenu item={item} key={item.name} activeKey={activeKey} openKey={openKey} onSelect={onSelect} 
										handleSheetPathSelect = {handleSheetPathSelect} onMouseEnter={onMouseEnter}
									></LeftMenu>
								)
							})
						}
						</ul>
					</div>
				)
			}
			else
			{
				return (
					<div id={item.name} className={className} key={key}>
						<ul className={firstClass}>
							<li className={liClass} onClick={( e ) => { handleSheetPathSelect(item.name, item.path, item, props.parent, sheets) }} >
								<a>{item.title}</a>
								<span className="rs-dropdown-toggle-caret"></span>
							</li>
						</ul>
						<ul id={"ul_" + item.name} className={ulClass} style={{display:'none'}}>
						{
							item.subcomponents.map((item, index) => {
								return(
									<LeftMenu item={item} key={item.name} activeKey={activeKey} openKey={openKey} onSelect={onSelect} 
										handleSheetPathSelect = {handleSheetPathSelect} onMouseEnter={onMouseEnter}
									></LeftMenu>
								)
							})
						}
						</ul>
					</div>
				)
			}
			
		}
			
	}
	else
	{
		let className = "menu frame-body-left-nav-item click";
		
		if( open===true )
		{
			className +=" active";
		}
		else
		{
			if( activeKey===item.name )
			{
				className +=" active";
			}
		}
		

		if( item.type!=="SHEET" && item.type!=="POPUP" )
		{
			if( icon!==undefined && icon!=="")
			{
				return (
					<ul className={firstClass} key={key}>
						<li className={className} key={key} onClick={()=>{onSelect(item.name)}} >
							<span className={iconClass}></span>	
							<Link to={{pathname:item.path, state:{node:item, item:item}}}>{item.title}</Link>
						</li>
					</ul>
				)
			}
			else
			{
				return (
					<ul className={firstClass} key={key}>
						<li className={className} key={key} onClick={()=>{onSelect(item.name)}} >
							<span className={iconClass}></span>	
							<Link to={{pathname:item.path, state:{node:item, item:item}}}>{item.title}</Link>
						</li>
					</ul>
				)
			}
		}
		
	}
}

export default Left